import type React from "react";
import { type FC, useState } from "react";
import { type Passcode, PasscodeContext } from "../hooks/usePasscodeContext";

export const PasscodeProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  const [passcode, setPasscode] = useState<Passcode>(null);
  return (
    <PasscodeContext.Provider value={{ passcode, setPasscode }}>
      {children}
    </PasscodeContext.Provider>
  );
};
